<script>
    export let header;
	export let subHeader;
	export let buttonLink;
	export let buttonText;
    export let imageSrc;
    
    import { getSizedImageUrl } from '@shopify/theme-images';

    function newLineToBr(text) {
        return text.replace(/\n/g, "<br/>");
    }
</script>
<style>
    .hero-image {
        background-image: var(--mobile-img);
    }

    @media(min-width: 768px) {  
        .hero-image {
            background-image: var(--desktop-img);
        }
    }

    .image-height {
        height: 45vh;
    }

    @media(min-width: 768px) {
        .image-height {
            height: 40vw;
        }    
    }

</style>

<div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
    <div>
        <div 
            class="tw-bg-left-top tw-bg-cover tw-bg-no-repeat tw-bg-center hero-image image-height" 
            style="--desktop-img: url({getSizedImageUrl(imageSrc, '2048x')}); --mobile-img: url({getSizedImageUrl(imageSrc, '720x')})"></div>
    </div>
    <div>
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center">
            <div class="tw-font-serif tw-text-3xl tw-m-4 tw-mt-12">
                {@html newLineToBr(header)}
            </div>
            <div class="tw-my-4 md:tw-mb-12 tw-leading-relaxed md:tw-max-w-lg">
                <div class="tw-max-w-xs">{@html newLineToBr(subHeader)}</div>
            </div>
            <div class="tw-m-4">
                <a href={buttonLink} class="tw-border tw-border-black tw-border-solid tw-uppercase tw-font-medium tw-font-sans tw-font-normal tw-py-3 tw-px-20 md:tw-px-28 tw-text-xs tw-cursor-pointer hover:tw-text-black hover:tw-border-green-200 hover:tw-bg-green-200 tw-tracking-heading">
                    <span>{buttonText}</span>
                </a>
            </div>
        </div>
    </div>
</div>

